import { render, staticRenderFns } from "./StickyModelElement.vue?vue&type=template&id=fbc0f802&scoped=true&"
import script from "./StickyModelElement.vue?vue&type=script&lang=js&"
export * from "./StickyModelElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc0f802",
  null
  
)

export default component.exports